import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/creators/{creatorId}/confido-payment-method-token']['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getConfidoPaymentMethodToken = async ({ creatorId, forUserId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/creators/{creatorId}/confido-payment-method-token', { creatorId });
  const data = await noodleApiClient.get(path, {
    params: { forUserId },
  });
  return data.data;
};

export default getConfidoPaymentMethodToken;
